import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateRangeComponent } from 'src/app/_shared/modules/form-component/date-range/date-range.component';
import { KaligraphiModule } from '@kalidea/kaligraphi';
import { ReactiveFormsModule } from '@angular/forms';
import { NumberRangeComponent } from 'src/app/_shared/modules/form-component/number-range/number-range.component';

const declarations = [
    DateRangeComponent,
    NumberRangeComponent,
];

@NgModule({
    declarations,
    exports: declarations,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        KaligraphiModule,
    ]
})
export class FormComponentsModule {
}
